import { http } from '../http';
import { unwrapSuccess } from '../helpers';

export async function listPlanItems(planId, page, size) {
    const res = await http.get(`/plans/${planId}/items`, {
        params: { page, size },
    });
    return unwrapSuccess(res);
}

export async function detailPlanItem(planId, id) {
    const res = await http.get(`/plans/${planId}/items/${id}`);
    return unwrapSuccess(res);
}

export async function createPlanItem(planId, payload) {
    const res = await http.post(`/plans/${planId}/items`, payload);
    return unwrapSuccess(res);
}

export async function updatePlanItem(planId, id, payload) {
    const res = await http.put(`/plans/${planId}/items/${id}`, payload);
    return unwrapSuccess(res);
}

export async function deletePlanItem(planId, id) {
    return http.delete(`/plans/${planId}/items/${id}`);
}

export async function sortPlanItems(planId, payload) {
    return http.post(`/plans/${planId}/items/sort`, payload);
}
